// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:559px){.MenuDetail.mb__popup-area input~.mb__popup-box[data-v-c663af08]{transition:top .3s,opacity .3s,z-index .3s}}", ""]);
// Exports
module.exports = exports;
